import { atom } from 'jotai'

export const saveState = atom<boolean>(false)
